import { render, staticRenderFns } from "./inventory-query.vue?vue&type=template&id=2c647b2e&scoped=true"
import script from "./inventory-query.vue?vue&type=script&lang=ts"
export * from "./inventory-query.vue?vue&type=script&lang=ts"
import style0 from "./inventory-query.vue?vue&type=style&index=0&id=2c647b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c647b2e",
  null
  
)

export default component.exports